import React from "react";
import { MoreVertical, Search, Upload, Edit2 } from "react-feather";
import Box from "./Box";
import BoxProfilePicture from "./BoxProfilePicture";
import LoadingCenter from "./LoadingCenter";
import SearchMessages from "./SearchMessages";
import FavoriteMessages from "./FavoriteMessages";
import DocDropzone from "./DocDropzone";
import BoxCustomerMenu from "./BoxCustomerMenu";
import ChartHours from "./ChartHours";

function ChatSidebar({
  isMessageSearch,
  isFavorite,
  favoritesPage,
  searchPage,
  informationPage,
  info,
  infoLoading,
  setKeyDownTerm,
  searchTerm,
  setSearchTerm,
  searchMessages,
  isSearchMessages,
  favoriteMessages,
  isFavoriteMessagesLoading,
  setMessageIdChat,
  openModalConditional,
  inputFilesRef,
  setButtonPopupTags,
  setButtonPopupObs,
  setButtonPopupSocialMedia,
}) {
  return (
    <div className="customer">
      <div className="header border-left">
        <span>{isFavorite ? "Favoritas" : isMessageSearch ? "Pesquisar" : "Informações"}</span>
        {info && (
          <div className="dropdown">
            <button className="dropdown__btn rounded__btn ml-10">
              <MoreVertical />
            </button>
            <ul className="dropdown__nav">
              <li className="dropdown__item">
                <a href="https://google.com" target="_blank" className="dropdown__link" onClick={searchPage}>Pesquisar</a>
              </li>
              <li className="dropdown__item">
                <a href="https://google.com" target="_blank" className="dropdown__link" onClick={informationPage}>Informações</a>
              </li>
              <li className="dropdown__item">
                <a href="http://" className="dropdown__link" onClick={favoritesPage}>Mensagens favoritas</a>
              </li>
            </ul>
          </div>
        )}
      </div>

      {isMessageSearch && (
        <div className="search">
          <div className="inner-search">
            <div className="search-icon">
              <Search size={24} />
            </div>
            <input
              type="text"
              className="search-input"
              placeholder="Pesquisar mensagem"
              onKeyDown={e => setKeyDownTerm(e)}
              onChange={e => setSearchTerm(e.target.value)}
              value={searchTerm}
            />
          </div>
        </div>
      )}

      {info ? (
        infoLoading ? (
          <LoadingCenter />
        ) : (
          isMessageSearch ? (
            <SearchMessages messages={searchMessages} isLoading={isSearchMessages} setMessageIdChat={setMessageIdChat} />
          ) : isFavorite ? (
            <FavoriteMessages messages={favoriteMessages} isLoading={isFavoriteMessagesLoading} setMessageIdChat={setMessageIdChat} />
          ) : (
            <div className="chat-user">
              <BoxProfilePicture user={info} />

              <button className="btn btn-success mb-20 mt-10 w-100" onClick={openModalConditional}>
                <p className="text-white" style={{ marginBottom: 0 }}>Condicional</p>
              </button>

              {info?.usadao_id !== "" && (
                <>
                  <BoxCustomerMenu user={info} />
                  <Box title="Documentos" icon={<Upload size={18} />} onClick={() => inputFilesRef.current.openFiles()} defaultOpen={true}>
                    <DocDropzone ref={inputFilesRef} user={info} />
                  </Box>
                </>
              )}

              <Box title="Tags" icon={<Edit2 size={18} />} onClick={() => setButtonPopupTags(true)} defaultOpen={true}>
                {info.tags.map((tag, index) => (
                  <div key={index} className="tag">
                    <span>#{tag.name}</span>
                  </div>
                ))}
              </Box>

              <Box title="Observação" icon={<Edit2 size={18} />} onClick={() => setButtonPopupObs(true)} defaultOpen={true}>
                <p className="text-color">{info.observation}</p>
              </Box>

              <Box title="Redes sociais" icon={<Edit2 size={18} />} onClick={() => setButtonPopupSocialMedia(true)} defaultOpen={false}>
                {info.socialMedias.map((media, index) => (
                  <img key={index} src={`${media.icon}`} style={{ marginRight: 10, marginBottom: 15 }} />
                ))}
              </Box>

              {info && <ChartHours user={info.id} />}
            </div>
          )
        )
      ) : (
        infoLoading ? (
          <LoadingCenter />
        ) : null
      )}
    </div>
  );
}

export default ChatSidebar;
